import ElmModal from "../elm_modal"
import { logDecodingError } from "../../helpers/airbrake"
import { pushGa4Event } from "../../helpers/ga4_helper"
import { ENTRY, prefetchEntry } from "../../helpers/prefetch"

declare global {
  interface Window {
    elmPackageVoucherFlags : Flags
  }
}

interface OccupancyOption extends Flags {
  occupancy: number
  arrivalOptions: Flags[]
}

const arrivalOptionsFlags = (options: Flags[], index: number): Flags => {
  const position = Math.max(0, Math.min(options.length - 1, index))

  return {
    before: options.slice(0, position),
    selected: options[position],
    after: options.slice(position + 1, options.length)
  }
}

const occupancyOptionsFlags = (occupancyOptions: OccupancyOption[], index: number): Flags => {
  const [first, second] = occupancyOptions
  const arrivalOptionPosition = Math.max(0, Math.min(first.arrivalOptions.length - 1, index))
  const flags = (option: OccupancyOption): Flags => ({
    occupancy: option.occupancy,
    arrivalOptions: {
      before: [],
      selected: option.arrivalOptions[arrivalOptionPosition],
      after: option.arrivalOptions.slice(arrivalOptionPosition + 1)
    }
  })

  return {
    before: [],
    selected: flags(first),
    after: second ? [flags(second)] : []
  }
}

const sessionStorageKey = (packageId : string) : string =>
  `packageVoucherSelectedArrival${packageId}`

const saveSelectedArrival = (packageId : string) => (selectedIndex : string) : void => {
  window.sessionStorage.setItem(sessionStorageKey(packageId), selectedIndex)
}

export default ({
  elmVenue,
  packageId,
  ecommerceItem,
  bookNowHandler
}: {
  elmVenue: ElmVenue,
  packageId: string,
  ecommerceItem: string,
  bookNowHandler: PortToElm<string>
}): void => {
  const modal = new ElmModal({ containerId: "elm-voucher-container" })
  const serverFlags = window.elmPackageVoucherFlags[packageId] as Flags
  const selectedIndex = window.sessionStorage.getItem(sessionStorageKey(packageId))
  let app
  let flags: Flags

  if (serverFlags.occupancyOptions) {
    flags = Object.assign({}, serverFlags, {
      occupancyOptions: occupancyOptionsFlags(
        serverFlags.occupancyOptions as OccupancyOption[],
        parseInt(selectedIndex || "0")
      ),
      ecommerceItem: JSON.parse(ecommerceItem)
    })
    app = elmVenue.NewPackageVoucher.init({ node: modal.node(), flags })
  } else {
    flags = Object.assign({}, serverFlags, {
      arrivalOptions: arrivalOptionsFlags(
        serverFlags.arrivalOptions as Flags[],
        parseInt(selectedIndex || "0")
      ),
      ecommerceItem: JSON.parse(ecommerceItem)
    })
    app = elmVenue.PackageVoucher.init({ node: modal.node(), flags })
  }

  app.ports.modalOpened.subscribe(modal.trapFocus)
  app.ports.arrivalSelected.subscribe(saveSelectedArrival(packageId))
  app.ports.flagDecodingError.subscribe(() => logDecodingError(flags))
  app.ports.bookNow.subscribe(bookNowHandler.send)
  app.ports.pushGa4Event.subscribe(pushGa4Event)

  prefetchEntry(ENTRY.VOUCHER_BOOKINGS)
}
